module.exports = __webpack_public_path__ + "static/img/Visualization6.64666e9d.png";